import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInvoiceById as GetInvoiceByIdQuery,
    GetInvoiceByIdVariables as GetInvoiceByIdVariables,
    GetInvoiceById_invoice as Invoice,
} from 'nutshell-graphql-types';

import GET_INVOICE_BY_ID from '../queries/get-invoice-by-id.graphql';

export const useGetInvoiceById = (
    id: string
): {
    invoice: Invoice | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetInvoiceByIdQuery, GetInvoiceByIdVariables>(
        GET_INVOICE_BY_ID,
        {
            variables: {
                id,
            },
        }
    );

    const invoice = data ? data.invoice : null;

    return {
        invoice,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
